import React, { useState } from 'react'
import {
  Container,
  Header,
  SpaceBetween,
  Box,
  Button,
  Tabs
} from '@cloudscape-design/components'
import AssetProperties from './AssetProperties'

interface SelectedAsset {
  _id: string
  name: string
  type: 'factory' | 'production_line' | 'equipment_component'
  status: string
  external_asset_id: string
  sitewise_asset_id?: string
}

interface AssetDetailsProps {
  asset: SelectedAsset
  onClose?: () => void
}

export default function AssetDetails({ asset, onClose }: AssetDetailsProps) {
  if (!asset) {
    return (
      <Container>
        <Box textAlign="center" color="inherit">
          <b>No asset selected</b>
          <Box variant="p" color="inherit">
            Select an asset from the hierarchy to view its details.
          </Box>
        </Box>
      </Container>
    )
  }

  const [activeTab, setActiveTab] = useState('properties')

  const tabs = [
    {
      id: 'properties',
      label: 'Properties',
      content: <AssetProperties asset={asset} />
    },
    {
      id: 'details',
      label: 'Details',
      content: (
        <Container>
          <SpaceBetween size="m">
            <Box>Type: {asset.type}</Box>
            <Box>Status: {asset.status}</Box>
            <Box>External ID: {asset.external_asset_id}</Box>
            {asset.sitewise_asset_id && <Box>SiteWise ID: {asset.sitewise_asset_id}</Box>}
          </SpaceBetween>
        </Container>
      )
    },
    {
      id: 'timeseries',
      label: 'Time Series',
      content: (
        <Container>
          <Box>Time series data for {asset.name} will be implemented here.</Box>
        </Container>
      )
    }
  ]

  return (
    <Container>
      <SpaceBetween size="m">
        <Header 
          variant="h2"
          actions={onClose && (
            <Button 
              variant="icon" 
              iconName="close" 
              onClick={onClose}
              ariaLabel="Close asset details"
            />
          )}
        >
          {asset.name}
        </Header>
        
        <Tabs
          tabs={tabs}
          activeTabId={activeTab}
          onChange={({ detail }) => setActiveTab(detail.activeTabId)}
        />
      </SpaceBetween>
    </Container>
  )
}